import { isDataUIPart, isTextUIPart } from "ai";
import type { ChatParts, PossibleDataTypes, UIMessageWithDataTypes } from "../types/chat-parts";

export const mapResponseToChatParts = (response: UIMessageWithDataTypes): ChatParts => {
  const content = response.parts
    ?.filter(part => isTextUIPart(part))
    .map(part => part.text)
    .join("") ?? "";

  const sources = response.parts
    .filter(part => part.type === "source-url");

  const dataParts = response.parts?.filter(part => isDataUIPart<PossibleDataTypes>(part)) ?? [];

  const warnings = dataParts
    .filter(part => part.type === "data-warning" as const)
    .map(part => part.data.message);

  const followUpQuestions = dataParts
    .filter(part => part.type === "data-follow-up-question")
    .map(part => part.data);

  const helpfulNextSteps = dataParts
    .filter(part => part.type === "data-helpful-next-step")
    .map(part => part.data);

  const traceId: string | undefined = dataParts
    .filter(part => part.type === "data-trace-id")
    .map(part => part.data)
    .at(-1);

  const observationId: string | undefined = dataParts
    .filter(part => part.type === "data-observation-id")
    .map(part => part.data)
    .at(-1);

  return {
    content,
    sources,
    warnings,
    followUpQuestions,
    helpfulNextSteps,
    traceId,
    observationId,
  };
};
